import { createSlice } from "@reduxjs/toolkit";
import { resetPatientData } from "../../../system/store/reset.slice";

const initialState = {
  data: null,
};

export const encounterDocsSlice = createSlice({
  name: "entities/patient-stats/encounter-docs-slice",
  initialState,
  reducers: {
    setEncounterDocs: (state, action) => {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetPatientData, () => initialState);
  },
});

export const { setEncounterDocs } = encounterDocsSlice.actions;

export default encounterDocsSlice.reducer;
